(function(root){
  'use strict';
  let moneyCurrency, moneyFormatter;
  function money(cents){
    const currency=/^[A-Z]{3}$/.test(root.HywellBundleCurrency)?root.HywellBundleCurrency:'USD';
    if(currency!==moneyCurrency){
      moneyCurrency=currency;
      moneyFormatter=new Intl.NumberFormat('en-US',{style:'currency',currency,currencyDisplay:'narrowSymbol'});
    }
    // Liquid variant prices are already in the customer's presentment currency.
    // The bundled symbol font renders the official UAE sign on older devices.
    return moneyFormatter.formatToParts(cents/100).map(part=>{
      if(part.type!=='currency')return part.value;
      if(currency==='AED')return '\u20c3';
      return part.value===currency&&typeof root.HywellBundleCurrencySymbol==='string'&&root.HywellBundleCurrencySymbol
        ?root.HywellBundleCurrencySymbol:part.value;
    }).join('');
  }
  const products = [
    {id:'boot',name:'Boot',price:2499,height:'11.8″',colors:['Black','Grey','Green'],defaultColor:'Green',images:{Black:'boot-black',Grey:'boot-gray',Green:'boot-green'},fit:'Tall work boots. Cold mornings. More coverage.',handle:'merino-wool-boot-socks'},
    {id:'crew',name:'Crew',price:2399,height:'8.7″',colors:['Black','Brown'],defaultColor:'Brown',images:{Black:'crew-black',Brown:'crew-brown'},fit:'Everyday work boots. Long shifts. Weekend trails.',handle:'merino-wool-crew-socks'},
    {id:'ankle',name:'Ankle',price:2299,height:'5.9″',colors:['Black','White'],defaultColor:'Black',images:{Black:'ankle-black',White:'ankle-white'},fit:'Work shoes and sneakers. Everyday movement.',handle:'merino-wool-ankle-socks'},
    {id:'no-show',name:'No-show',price:2199,height:'2.8″',colors:['Black'],defaultColor:'Black',images:{Black:'no-show-black'},fit:'Low-top shoes. Warm days. A lower profile.',handle:'merino-wool-no-show-socks'},
  ];
  const bundles = [
    {id:'family',name:'Family Stock-Up',kicker:'THE EVERYDAY RESERVE',tag:'BEST VALUE',description:'A dependable rotation for the household, with comfort to spare.',quantities:[5,3,2,0],featured:true},
    {id:'workweek',name:'Workweek & Trail',kicker:'MONDAY THROUGH SUNDAY',tag:'THE 5-PAIR ROTATION',description:'Three pairs for tall boots. Two versatile pairs for work and the trail.',quantities:[3,2,0,0],featured:true},
    {id:'winter',name:'Winter Work Kit',kicker:'FOR THE COLD STARTS',tag:'ALL BOOT. ALL COMFORT.',description:'More coverage for cold outdoor shifts and tall work boots.',quantities:[5,0,0,0]},
    {id:'summer',name:'Home & Travel',kicker:'PACK LIGHT. STEP EASY.',tag:'LOWER PROFILE',description:'Your low-cut rotation for sneakers, warm days and days away.',quantities:[0,0,2,3]},
    {id:'discover',name:'Meet the Merino Line',kicker:'FIND YOUR FAVORITE',tag:'ALL FOUR LENGTHS',description:'Try one of each length. Find the pairs that fit your everyday.',quantities:[1,1,1,1]},
  ];
  const variantIds={
    boot:{Black:{M:51726550335669,L:51726550433973,XL:51726550532277},Grey:{M:51726550040757,L:51726550139061,XL:51726550237365},Green:{M:51909645729973,L:51909645828277,XL:51909645926581}},
    crew:{Black:{M:52424578269365,L:52424578302133,XL:52424578334901},Brown:{M:53012850966709,L:53012850999477,XL:53012851032245}},
    ankle:{Black:{M:52424579612853,L:52424579645621,XL:52424579678389},White:{M:53012861255861,L:53012861288629,XL:53012861321397}},
    'no-show':{Black:{M:52424579874997,L:52424579907765,XL:52424579940533}},
  };
  products.forEach(product=>{
    product.variantIds=variantIds[product.id];
    const live=root.HywellBundleVariants?.[product.id]?.[0];
    if(live&&Number.isSafeInteger(live.price))product.price=live.price;
  });
  function checkoutURL(lines,liveVariants=root.HywellBundleVariants){
    const quantities=new Map();
    for(const line of lines){
      if(!Number.isSafeInteger(line.quantity)||line.quantity<0)throw new RangeError('Choose a whole number of pairs.');
      if(!line.quantity)continue;
      const product=products.find(p=>p.id===line.id);
      if(!product||!product.colors.includes(line.color)||!['M','L','XL'].includes(line.size))throw new RangeError('Choose a valid sock style, color and size.');
      const variant=liveVariants?liveVariants[product.id]?.find(v=>v.color===line.color&&v.size===line.size):{id:product.variantIds[line.color][line.size],available:true};
      if(!variant||!variant.available||!Number.isSafeInteger(variant.id)||variant.id<=0)throw new RangeError(`${product.name} in ${line.color} / ${line.size} is currently unavailable. Please choose another option.`);
      const quantity=(quantities.get(variant.id)||0)+line.quantity;
      if(!Number.isSafeInteger(quantity))throw new RangeError('Too many pairs selected.');
      quantities.set(variant.id,quantity);
    }
    if(!quantities.size)throw new RangeError('Add at least one pair before checking out.');
    return 'https://www.hywellstore.com/cart/'+[...quantities].map(([id,quantity])=>`${id}:${quantity}`).join(',');
  }
  function openCheckout(lines,browser=root){
    const url=checkoutURL(lines,browser.HywellBundleVariants);
    if(browser.self!==browser.top){browser.open(url,'_blank','noopener');return 'new-tab';}
    browser.location.assign(url);
    return 'same-tab';
  }
  const api={products,bundles,money,checkoutURL,openCheckout};
  if(typeof module!=='undefined' && module.exports) module.exports=api;
  else root.BundleCatalogue=api;
})(typeof globalThis!=='undefined'?globalThis:this);
